import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { get, valuesIn, filter, pick, merge, intersectionWith, map, omit, find, orderBy } from 'lodash';

import DropDownMenu from './c_DropDownMenu';

import SearchIcon from '../svgs/SearchIcon';
import {lookup, getLookupValue} from '../../redux/helpers/staticData';
import moment from 'moment';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table';

@connect((store, props) => {
  const staticData = store.staticData;

  return {
    staticData,
  };
})
export default class AssignmentTable extends Component {

  static propTypes = {
		dispatch : PropTypes.func.isRequired,
		assignmentList: PropTypes.object,
		staticData: PropTypes.object,
    showHeader: PropTypes.bool,
    showSearch: PropTypes.bool,
    showFilters: PropTypes.bool,
    columns: PropTypes.array
	}

  constructor(props, context) {
    super(props, context);
  }

  state = {
    showHeader: get(this.props, 'showHeader', true),
    showSearch: get(this.props, 'showSearch', true),
    showFilters: get(this.props, 'showFilters', true),
    columns: this.props.columns !== undefined ? this.props.columns : [
      'Id',
      'Title',
      'Date',
      'Status'
    ],
    sortBy: {
      field: 'id',
      order: 'asc'
    }
  };

  generateMenuItems(staticData, type){

      let object = staticData[type];

      return  map(object,function(item) {
        return {
          value: item.id,
          primaryText: (item.name || item.primaryText)
        }
    });
  }

  onChangeFilter(filterName){
    return (event, key, payload) => {
     let newFilters;
      switch(filterName){

        default:
        break;
      }

    }
  }

  onChangeSearch(event){
      const value = event.target.value ? String(event.target.value) : null;
      this.setState({filters: merge(this.state.filters, {id: value})});
  }


  /*
   * Render functions for each column
   */

  renderId(header, row, index) {
    return this.renderIdWithLink(header, row, index, true);
  }

  renderIdNoLink(header, row, index) {
    return this.renderIdWithLink(header, row, index, false);
  }


  renderIdWithLink(header, row, index, showLink) {
    if (header) {
      return <TableHeaderColumn className='asmnt-number'>Asgmt #</TableHeaderColumn>
    }

    return <TableRowColumn data-id={`Asmnt Number${index}`} className='asmnt-number'>
      {showLink
        &&
        <div className='text-link' onClick={(e) => console.log(row.id)}>{row.id}</div>
        ||
        <div>{row.id}</div>
      }

    </TableRowColumn>
  }

  renderDate(header, row, index) {
    if (header) {
      return <TableHeaderColumn className='asmnt-date'>Date</TableHeaderColumn>
    }

    return <TableRowColumn data-id={`Date ${index}`} className='asmnt-date'>
      {moment(row.dateCreated).format('L')}
    </TableRowColumn>
  }

  renderTitle(header, row, index) {
    if (header) {
      return <TableHeaderColumn className='asmnt-title'>Title</TableHeaderColumn>
    }

    return <TableRowColumn data-id={`Asmnt Title${index}`} className='asmnt-title'>
      {'Title'}
    </TableRowColumn>
  }

  renderStatus(header, row, index, status) {
    if (header) {
      return <TableHeaderColumn className='status'>Status</TableHeaderColumn>
    }

    return <TableRowColumn data-id={`Status #${index}`} className='status'>
      <div className='status-circle' data-id='Status Icon' style={{backgroundColor: status.color, borderColor: status.color}}></div>{status.name}
    </TableRowColumn>
  }

  render() {

    const {assignmentList, dispatch} = this.props || {};

      return (
        <div className='assignment-table info-table'>
        {this.state.showSearch
          &&
          <header className='assignment-header'>
            {this.state.showHeader
              &&
              <div className='assignment-title-container'>
                <h1 className='assignment-title'>ASSIGNMENTS</h1>
              </div>
            }
            <div className='assignment-search-container'>
              <div className='assignment-search'>
                <SearchIcon />
                <input onChange={ (event) => this.onChangeSearch(event) }  data-id='Search'
                         ref='search'
                         className='search-input'
                         type='text'
                         placeholder='Search by ID...'/>
              </div>
            </div>
          </header>
        }


          {this.state.showFilters
            &&
            <div className='assignment-filter'>

            </div>
          }


          <div className='assignment-table-section'>
            <Table selectable={false} multiSelectable={false}>
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                  {map(this.state.columns, (column) => {
                    return this['render'+column](true);
                  })}
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false}>
                {assignmentList.length == 0
                  &&
                  <div className="table-no-data">No Assignments Available</div>
                }
                {map(assignmentList, (row, index) => {
                  const status = getLookupValue(this.props.staticData, 'assignmentStatus', {id: row.assignmentStatus})
                  return <TableRow key={`${row.id}`} data-id={`Contact ${row.id}`}>
                      {map(this.state.columns, (column) => {
                        return this['render'+column](false, row, index, status);
                      })}
                    </TableRow>
                })
    }
              </TableBody>
            </Table>
          </div>
        </div>
    );

  }
}



// WEBPACK FOOTER //
// ./shared/common/components/AssignmentTable.js